import PdfImg from "assets/images/svg-icons/pdfFileIcon.svg";
import VideoImg from "assets/images/svg-icons/videoFileIcon.svg";
import ImageImg from "assets/images/svg-icons/imgFileIcon.svg";
import MusicImg from "assets/images/svg-icons/musicFileIcon.svg";
import DocImg from "assets/images/svg-icons/docFileIcon.svg";
import ZipImg from "assets/images/svg-icons/zipFileIcon.svg";

export const getFileType = (fileType) => {
  if (!fileType) return DocImg;

  const type = fileType?.toLowerCase();
  // Handle both "jpg" and ".jpg" formats
  const ext = type.startsWith(".") ? type : `.${type}`;

  if (
    [
      ".jpg",
      ".jpeg",
      ".png",
      ".gif",
      ".webp",
      ".svg",
      ".heif",
      ".heic",
      ".tiff",
      ".dng",
      ".bmp",
    ].includes(ext)
  ) {
    return ImageImg;
  }

  if ([".pdf"].includes(ext)) {
    return PdfImg;
  }

  if (
    [
      ".mp4",
      ".mov",
      ".avi",
      ".mkv",
      ".wmv",
      ".flv",
      ".webm",
      ".m4v",
      ".3gp",
      ".mpeg",
      ".mpg",
      ".mts",
      ".m2ts",
      ".ogv",
      ".vob",
      ".rm",
      ".rmvb",
      ".divx",
      ".asf",
    ].includes(ext)
  ) {
    return VideoImg;
  }

  if ([".mp3", ".wav", ".aac", ".ogg", ".flac", ".m4a", ".amr"].includes(ext)) {
    return MusicImg;
  }

  if (
    [
      ".doc",
      ".docx",
      ".ppt",
      ".pptx",
      ".xls",
      ".xlsx",
      ".txt",
      ".csv",
    ].includes(ext)
  ) {
    return DocImg;
  }

  if ([".zip", ".rar", ".7z", ".tar", ".gz"].includes(ext)) {
    return ZipImg;
  }

  return DocImg;
};
